import React from 'react';
import {Link} from "react-router-dom";
import IconName from "../../../svgLogo/SvgLogo";
import TotalPrice from "./TotalPrice";
import AddressSend from "./AddressSend";
import Products from "./Products";
import Header from "../../header/Header";

const FinalApproval = () => {
    return (
        <div className="final-approval-wrapper">
            <Header/>
            <div className="final-approval-content">
                <div className="factor-content">
                    <div className="container">
                        <AddressSend/>
                        <div className="products-content">
                            <div className="title xmb-8">
                                <div className="title-box just-text title-box-blue">
                                    <div className="title-bg">
                                        <h2 className="text">
                                            مرسولات </h2>
                                    </div>
                                </div>
                            </div>
                            <Products/>
                            <div className="product-description xmt-6">
                                <textarea placeholder="توضیحات سفارشات مانند: رنگ، کادوپیچی ..."/>
                            </div>
                            <div className="error-max-price xmt-6 xmt-lg-8">
                                <IconName name="alert" className="icon"/>
                                <span className="text persian-number">به دلیل این که مبلغ سفارش شما بیش از سقف برداشت پیشفرض شبکه بانکی (۵۰,۰۰۰,۰۰۰ تومان) می‌باشد، سفارش شما دارای ۲ تراکنش می باشد و پس از پرداخت تمامی تراکنش ها، وضعیت سفارش شما به در حال آماده سازی تغییر خواهد کرد</span>
                            </div>
                            <div className="alert-payment xmt-4">
                                <IconName name="alert" className="icon"/>
                                <span className="text persian-number">کاربر عزیز لطفا توجه بفرمایید، سایمان دیجیتال یک فروشگاه خرده فروشی آنلاین بوده و هدف ما ارائه و فروش محصول مستقیما به مصرف کننده نهایی می باشد. به منظور ارائه خدمات مطلوبتر هر مصرف کننده نهایی کالا با مشخصات یکتا (شامل کد ملی شاخص ،کارت بانکی و آدرس تحویل و آدرس ایمیل منحصر به فرد و سایر اطلاعات مندرج در سفارش) قادر به خرید یک عدد از کالاهای موجود در فروشگاه بوده و چنانچه سفارش ثبت شده شما با شرایط مذکور مطابقت نداشته باشد، سفارش شما جهت عودت وجه به وضعیت در انتظار بررسی تغییر یافته و وجه سفارش پس از گذشت پنج روز کاری به حساب شما عودت خواهد شد.</span>
                            </div>
                            <TotalPrice/>
                            <div className="policy-check xmt-6">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <div className="form-check-label">
                                        <a href="#" className="link">شرایط و قوانین</a>
                                        <span
                                            className="text"> خرید کالا از سایمان دیجیتال را خوانده ام و با آن موافقم </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="step-buy-cart-final position-fixed">
                <div className="container d-flex justify-content-between align-items-center">
                    <div className="prev-button">
                        <Link to="/productDelivery" className="text">قبلی</Link>
                    </div>
                    <div className="step-buy">
                        <ul className="nav persian-number">
                            <li className="nav-item before">
                                <Link to="/cartPage">
                                    <div className="step"><span>1</span></div>
                                    <div
                                        className="text">سبد خرید
                                    </div>
                                </Link>
                            </li>
                            <li className="nav-item before">
                                <Link to="/infoUser">
                                    <div className="step"><span>2</span></div>
                                    <div
                                        className="text">تکمیل اطلاعات
                                    </div>
                                </Link>
                            </li>
                            <li className="nav-item before">
                                <a href="#">
                                    <div className="step"><span>3</span></div>
                                    <div
                                        className="text">شیوه‌ی ارسال
                                    </div>
                                </a>
                            </li>
                            <li className="nav-item active">
                                <a href="#">
                                    <div className="step"><span>4</span></div>
                                    <div
                                        className="text">تایید نهایی
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="step-circle-buy d-flex d-lg-none">
                        <div className="nav-item">
                            <a href="#" className="step-buy"><span className="step"></span></a>
                        </div>

                        <div className="nav-item">
                            <a href="#" className="step-buy"><span className="step"></span></a>
                        </div>
                        <div className="nav-item">
                            <a href="#" className="step-buy active"><span className="step"></span></a>
                        </div>
                    </div>
                    <div className="button-next info-button d-none d-lg-flex">
                        <Link to="/success">
                            <span className="text">پرداخت و ثبت نهایی سفارش</span>
                            <IconName name="chevron_left" className="icon"/>
                        </Link>
                    </div>
                    <div className="button-next info-button d-flex d-lg-none">
                        <Link to="/success">
                            <span className="text">پرداخت</span>
                            <IconName name="chevron_left" className="icon"/>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinalApproval;
